module.exports = __webpack_public_path__ + "img/9.2d940782.jpg";